export var OutcomeType;
(function (OutcomeType) {
    OutcomeType["Home"] = "Home";
    OutcomeType["Tie"] = "Tie";
    OutcomeType["Draw"] = "Draw";
    OutcomeType["Away"] = "Away";
    OutcomeType["OneOrX"] = "1X";
    OutcomeType["XOrTwo"] = "X2";
    OutcomeType["OneTwo"] = "12";
    OutcomeType["Over"] = "Over";
    OutcomeType["Exactly"] = "Exactly";
    OutcomeType["Under"] = "Under";
    OutcomeType["Yes"] = "Yes";
    OutcomeType["No"] = "No";
    OutcomeType["Odd"] = "Odd";
    OutcomeType["Even"] = "Even";
    OutcomeType["ToScoreFirst"] = "ToScoreFirst";
    OutcomeType["ToScoreLast"] = "ToScoreLast";
    OutcomeType["ToScoreAnyTime"] = "ToScoreAnyTime";
    OutcomeType["ToScoreFirstOrLast"] = "ToScoreFirstOrLast";
    OutcomeType["ToScore2OrMore"] = "ToScore2OrMore";
    OutcomeType["ToScore3OrMore"] = "ToScore3OrMore";
})(OutcomeType || (OutcomeType = {}));
//# sourceMappingURL=OutcomeType.js.map